import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function Categories({ children }) {
  useInjectSaga({ key: 'categories', saga });
  useInjectReducer({ key: 'categories', reducer });

  return React.Children.only(children);
}

Categories.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withCategories } from './withCategories';
export default compose(withConnect, memo)(Categories);
